import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionModule } from '@app/shared/components/accordion/accordion.module';
import { FormRadioModule } from '@app/shared/components/form/components/form-radio/form-radio.module';
import { FooterComponent } from '@app/core/footer/footer.component';
import { PaymentMethodsService } from '@vestiaire/api-sdk-angular';
import { SvgModule } from '@app/shared/components/svg/svg.module';
import { RouterModule } from '@angular/router';
import { FooterNavSectionComponent } from '@app/core/footer/components/footer-nav-section/footer-nav-section.component';
import { SharedModule } from '@app/shared/shared.module';
import { FooterCopyrightComponent } from './components/footer-copyright/footer-copyright.component';
import { FooterDisclaimerComponent } from './components/footer-disclaimer/footer-disclaimer.component';
import { FooterLegalsComponent } from './components/footer-legals/footer-legals.component';
import { FooterSocialSectionComponent } from './components/footer-social-section/footer-social-section.component';
import { FooterPaymentModeComponent } from './components/footer-payment-mode/footer-payment-mode.component';
import { I18nModule } from '@app/core/i18n/i18n.module';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, AccordionModule, FormRadioModule, SvgModule, I18nModule],
  declarations: [
    FooterComponent,
    FooterNavSectionComponent,
    FooterCopyrightComponent,
    FooterDisclaimerComponent,
    FooterLegalsComponent,
    FooterSocialSectionComponent,
    FooterPaymentModeComponent
  ],
  exports: [FooterComponent],
  providers: [PaymentMethodsService]
})
export class FooterModule {}
